export enum TabNames {
  Properties = "Properties",
  SelectedProperties = "SelectedProperties",
}

export enum PropertyTabNames {
  ShortListedProperties = "Short Listed Properties",
  SearchProperties = "Search Properties",
}

export enum AccordionTab {
  Properties = "Properties",
  SelectPropery = "Select Property",
  SortProperties = "Sort Property",
  LocationMap = "Location Map",
  ProposalForm = "Proposal Form",
  GalleryPopup = "Galler Popup",
}
